import { isEqual } from 'lodash-es';

import { useStoreSelector } from '../../../../core/store/selector.js';
import { HistogramChartStateContext } from '../../contexts/HistogramChartState.context.js';
import { HistogramChartState } from '../../types/state.js';

export const useSelector = <T>(
  selector: (state: HistogramChartState) => T,
  isEqual?: (a: T, b: T) => boolean,
): T => useStoreSelector(HistogramChartStateContext, selector, isEqual);

export const useFilteredSeriesIdsState = () =>
  useSelector((state) => state.filteredSeriesIds);

export const useHighlightedSeriesIdState = () =>
  useSelector((state) => state.highlightedSeriesId);

export const useCurrentDomainState = () =>
  useSelector((state) => state.currentDomain);

export const useZoomState = () => useSelector((state) => state.zoom);

export const useHoveredThresholdIdState = () =>
  useSelector((state) => state.hoveredThresholdId);

export const useAnnotationsState = () =>
  useSelector((state) => state.annotations);

export const useInteractionModeState = () =>
  useSelector((state) => state.interactionMode);

export const useExploreState = () =>
  useSelector((state) => state.explore, isEqual);

export const useSelectState = () =>
  useSelector((state) => state.select, isEqual);

export const useClosestBinsState = () =>
  useSelector((state) => state.closestBins, isEqual);
